import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode, faChartLine, faPencilRuler, faUserMd, faBullhorn, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import DigitalMimg from '../../src/img/dm.jpg'
import { BsCaretDownSquareFill } from "react-icons/bs";
import DoctorSpc from '../img/Software_Doctor.webp'
import WebDesign from '../img/webdesign.jpg'
import WebDevelopment from '../img/WebApps.jpg'
import Digital360 from '../img/360_digital_marketing.jfif'
import SEO from '../img/SEO.png'

let backgroundImage = [
  DoctorSpc,
  WebDesign,
  WebDevelopment,
  Digital360,
  SEO
]

// Service data as provided in the prompt
const servicesData = [
  {
    title: "Doctor Special",
    url: "/online-appointment-system",
    icon: DoctorSpc,
    key: 1,
    description: "Comprehensive digital solutions for healthcare professionals",
    dropdownItems: [
      { title: "Online Appointment System", url: "/online-appointment-system" },
      { title: "Dynamic Website", url: "/dynamic-web-apps" },
      { title: "Campaigning & Lead Generation", url: "/lead-generation" },
      { title: "Social Media Management", url: "/online-reputation-management" },
      { title: "Digital Marketing", url: "/digital-marketng-for-doctor" },
      { title: "SEO & Youtube", url: "/seo-youtube-for-doctor" },
    ],
  },
  {
    title: "Web Design",
    url: "/graphic-designing",
    icon: WebDesign,
    key: 2,
    description: "Beautiful, responsive designs that convert visitors",
    dropdownItems: [
      { title: "Graphic Design", url: "/graphic-designing" },
      { title: "Logo & Branding", url: "/logo-designing" },
      { title: "Custom Web Design", url: "/custom-web-designing" },
      { title: "Wordpress Design", url: "/wordpress-design" },
      { title: "E-Commerce Design", url: "/custom-e-commerce-design" },
      { title: "Woo-Commerce", url: "/woo-commerce-design" },
    ],
  },
  {
    title: "Web / Apps Development",
    url: "/web-development",
    icon: WebDevelopment,
    key: 3,
    description: "Robust applications built with modern technologies",
    dropdownItems: [
      { title: "Web Development", url: "/web-development" },
      { title: "Mobile App Development", url: "/mobile-app-development" },
      { title: "Software Development", url: "/software-development" },
      { title: "SAAS Development", url: "/saas-development" },
    ],
  },
  {
    title: "360 Digital Marketing",
    url: "/social-media-marketing",
    icon: Digital360,
    key: 4,
    description: "End-to-end marketing strategies for maximum reach",
    dropdownItems: [
      { title: "Social Media Marketing", url: "/social-media-marketing" },
      { title: "PPC", url: "/ppc" },
      
      { title: "Email Marketing", url: "/email-marketing" },
      { title: "Linkedin Marketing", url: "/linkdin-marketing" },
      { title: "Analytics", url: "/analytics" },
      { title: "Social Media Management", url: "/social-media-reputation-management" },
    ],
  },
  {
    title: "SEO Services",
    url: "/career",
    icon: SEO,
    key: 5,
    description: "Boost your visibility and dominate search rankings",
    dropdownItems: [
      { title: "SEO for Small Business", url: "/seo-for-small-business" },
      { title: "Local SEO (GMB)", url: "/local-seo-gmb" },
      { title: "Custom SEO Solution", url: "/custom-seo-solution" },
      /* { title: "E-commerce SEO", url: "/chairman-desk" }, */
      { title: "SEO Audit", url: "/seo-audit" },
      /* { title: "Analytics & Reporting", url: "/chairman-desk" }, */
    ],
  },
];

const Container = styled.div.attrs(() => ({
  className: "py-16 bg-gradient-to-br from-gray-50 to-blue-50",
}))`
  font-family: 'Poppins', sans-serif;
`;

const SectionTitle = styled.h2.attrs(() => ({
  className: "text-4xl md:text-5xl font-extrabold text-center text-gray-900 mb-4",
}))`
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const Subtitle = styled.p.attrs(() => ({
  className: "text-center text-gray-600 mb-12 max-w-2xl mx-auto text-lg",
}))``;

const ServiceGrid = styled.div.attrs(() => ({
  className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-4",
}))`
  max-width: 1400px;
  margin: 0 auto;
`;

const ServiceCard = styled.div.attrs(() => ({
  className: "relative bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 border border-gray-100",
}))`
  cursor: pointer;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  
  &:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }
`;

const CardHeader = styled.div.attrs((props) => ({
  className: "p-8 flex flex-col items-center text-center rounded-t-2xl relative overflow-hidden",
}))`
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
  color: white;
  min-height: 280px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  transition: all 0.5s ease;

  ${ServiceCard}:hover & {
    transform: scale(1.05);
  }

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(30, 58, 138, 0.8) 0%, rgba(59, 130, 246, 0.7) 100%);
    z-index: 0;
    transition: all 0.4s ease;
  }

  ${ServiceCard}:hover &::before {
    background: linear-gradient(135deg, rgba(30, 58, 138, 0.9) 0%, rgba(59, 130, 246, 0.8) 100%);
  }

  & > * {
    position: relative;
    z-index: 2;
  }
`;

const ContentOverlay = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 20px;
  border-radius: 16px;
  width: 100%;
  max-width: 320px;
  margin-bottom: 20px;
  transform: translateY(${props => props.expanded ? '0' : '10px'});
  transition: all 0.4s ease;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  
  ${ServiceCard}:hover & {
    transform: translateY(0);
  }
`;

const CardTitle = styled.h3.attrs(() => ({
  className: "text-2xl font-bold mb-3",
}))`
  background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const CardDescription = styled.p.attrs(() => ({
  className: "text-gray-600 text-sm mb-4",
}))``;

const CardLink = styled.a.attrs(() => ({
  className: "inline-flex items-center text-blue-600 hover:text-blue-800 font-semibold transition-all duration-300 group",
}))`
  &:hover {
    transform: translateX(5px);
  }
`;

const LearnMoreText = styled.span`
  margin-right: 8px;
`;

const DropdownContainer = styled.div`
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  
  &.expanded {
    max-height: 600px;
    transition: max-height 0.7s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

const DropdownList = styled.ul.attrs(() => ({
  className: "bg-gradient-to-b from-white to-gray-50 p-6 border-t border-gray-100",
}))``;

const DropdownItem = styled.li.attrs(() => ({
  className: "mb-3 last:mb-0 transform transition-transform duration-300 hover:translate-x-2",
}))`
  text-align: left;
`;

const DropdownLink = styled.a.attrs(() => ({
  className: "block py-3 px-4 rounded-xl text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-300 border border-transparent hover:border-blue-200 font-medium",
}))`
  position: relative;
  
  &::before {
    content: "▸";
    position: absolute;
    left: 12px;
    color: #3b82f6;
    transition: transform 0.3s ease;
  }
  
  padding-left: 30px;
  
  &:hover::before {
    transform: translateX(3px);
  }
`;

const ExpandIcon = styled(BsCaretDownSquareFill)`
  transition: all 0.4s ease;
  transform: ${props => props.expanded ? 'rotate(180deg)' : 'rotate(0)'};
  color: #3b82f6;
  
  ${ServiceCard}:hover & {
    transform: ${props => props.expanded ? 'rotate(180deg)' : 'translateY(2px)'};
  }
`;

const IconImage = styled.img.attrs(() => ({
  className: "w-16 h-16 mx-auto mb-4 opacity-90",
}))``;

const servicesWithImages = servicesData.map(service => {
  return { 
    ...service, 
    backgroundImage: service.icon 
  };
});

const ServicesComponent = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDropdown = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <Container>
      <div className="max-w-7xl mx-auto text-center">
        <SectionTitle>Our Services</SectionTitle>
        <Subtitle>
          We offer a comprehensive suite of digital solutions to help you achieve your business goals. 
          Explore our range of specialized services designed for excellence.
        </Subtitle>
        <ServiceGrid>
          {servicesWithImages.map((service, index) => (
            <ServiceCard key={service.key} onClick={() => toggleDropdown(index)}>
              <CardHeader backgroundImage={service.backgroundImage} className="group">
                <ContentOverlay expanded={expandedIndex === index}>
                  <CardTitle>{service.title}</CardTitle>
                  <CardDescription>{service.description}</CardDescription>
                  <div className="flex items-center justify-between">
                    <CardLink href={service.url} onClick={(e) => e.stopPropagation()}>
                      <LearnMoreText>Learn More</LearnMoreText>
                      <FontAwesomeIcon icon={faArrowRight} className="transform group-hover:translate-x-1 transition-transform" />
                    </CardLink>
                    <ExpandIcon expanded={expandedIndex === index} className="text-xl" />
                  </div>
                </ContentOverlay>
              </CardHeader>
              <DropdownContainer className={expandedIndex === index ? 'expanded' : ''}>
                <DropdownList>
                  {service.dropdownItems.map((item, subIndex) => (
                    <DropdownItem key={subIndex}>
                      <DropdownLink href={item.url} onClick={(e) => e.stopPropagation()}>
                        {item.title}
                      </DropdownLink>
                    </DropdownItem>
                  ))}
                </DropdownList>
              </DropdownContainer>
            </ServiceCard>
          ))}
        </ServiceGrid>
      </div>
    </Container>
  );
};

export default ServicesComponent;